var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeet({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "96.000000pt",
    height: "96.000000pt",
    viewBox: "0 0 96.000000 96.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,96.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M375 866 c-112 -28 -215 -109 -262 -205 -23 -47 -27 -69 -27 -141 0 -72 4 -94 27 -141 61 -125 214 -219 360 -219 l47 0 0 -50 c0 -42 3 -50 18 -50 50 0 220 153 279 251 44 73 67 168 59 242 -23 221 -264 372 -501 313z m-20 -346 c0 -33 -2 -35 -35 -35 -29 0 -36 4 -38 23 -6 40 5 54 40 50 30 -3 33 -6 33 -38z m160 0 c0 -33 -2 -35 -35 -35 -29 0 -36 4 -38 23 -6 40 5 54 40 50 30 -3 33 -6 33 -38z m160 0 c0 -33 -2 -35 -35 -35 -29 0 -36 4 -38 23 -6 40 5 54 40 50 30 -3 33 -6 33 -38z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeet);
export default __webpack_public_path__ + "static/media/meet.b91d7a6e01c5969693094b85acdf3b1c.svg";
export { ForwardRef as ReactComponent };